import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import PrivateLayout from 'components/Container/PrivateLayout';
import { CheckinPage } from 'components/Pages/Admin/CheckinPage';
import MarketPlace from 'components/Pages/Public/MarketPlace';
import AsyncComponent from 'components/Shared/AsyncComponent';
import dayjs from 'dayjs';
import Maintenance from 'Pages/Maintenance';
import { PrintProvider } from 'Pages/PurchaseMade/ApprovedPayment/Ticket/context';

import AthenticatedRoutes from './AuthenticatedRoutes';
import Gateway from './Gateway';
import eventRoutes from './PublicRoutes/eventRoutes';
import { EventRoutes } from './PublicRoutes/eventRoutes/types';
import generalRoutes from './PublicRoutes/generalRoutes';
import { GeneralRoutes } from './PublicRoutes/generalRoutes/types';
import pushcaseMadeRoutes from './PublicRoutes/pushcaseMadeRoute';
import { PushcaseMadeRoutes } from './PublicRoutes/pushcaseMadeRoute/types';

import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

const Routes = () => {
  const renderGeneralRoutes = (route: GeneralRoutes) => {
    return (
      <Route
        key={route.path}
        path={route.path}
        exact
        component={AsyncComponent(() => import('components/Pages/' + route.import))}
      />
    );
  };

  const renderPushcaseMadeRoutes = (route: PushcaseMadeRoutes) => {
    return (
      <Route
        key={route.path}
        path={route.path}
        exact
        component={AsyncComponent(() => import('Pages/' + route.import))}
      />
    );
  };

  const renderEventRoutes = (route: EventRoutes) => {
    return (
      <Route
        path={route.path}
        key={route.path}
        exact
        component={AsyncComponent(() => import('Pages/' + route.import))}
      />
    );
  };

  const renderMaintenance = () => {
    const isInMaintenance = process.env.REACT_APP_IS_IN_MAINTENANCE === 'true';
    return isInMaintenance && <Route path='/' component={() => <Maintenance />} />;
  };

  const betaAccess = new URLSearchParams(window.location.search).get('beta') === 'd7fe59e239b0';
  const isMarketplaceAvailable = new Date() >= new Date('2025-05-26T00:00:00-03:00') || betaAccess;

  return (
    <BrowserRouter getUserConfirmation={() => null}>
      <PrintProvider>
        <Switch>
          {renderMaintenance()}
          {eventRoutes.map(renderEventRoutes)}
          {generalRoutes.map(renderGeneralRoutes)}
          {pushcaseMadeRoutes.map(renderPushcaseMadeRoutes)}
          {isMarketplaceAvailable && <Route path={'/marketplace'} component={MarketPlace} />}
          <Route path={'/event/staff-checkin'} component={CheckinPage} />
          <PrivateLayout>
            <Gateway path='/' component={AthenticatedRoutes} />
          </PrivateLayout>
          <Route render={() => <Redirect to='/' />} />
        </Switch>
      </PrintProvider>
    </BrowserRouter>
  );
};

export default Routes;
